import React from 'react'
import Pt from 'prop-types'
import Ipt from 'react-immutable-proptypes'
import { Col, HelpBlock, Panel, Row } from 'react-bootstrap'

import { FormField } from 'internal-components/src/components/Form'

export default function HostnameDetails({ errors, setData, signup }) {
  return (
    <div className="hostname-details">
      <h4>Hosting Domain Details</h4>

      <Row>
        <Col md={4} mdPush={8}>
          <Panel>
            <Panel.Body>
              <h4>Domain Nameservers</h4>

              <p>
                Setting up a hosting account requires that your domain name be
                configured to point to our nameservers. The domain registrar you
                used will have a configuration area where you can adjust the
                nameservers of your domain.
              </p>

              <p>Point your domain name to:</p>

              <ul>
                <li>ns1.infinite.net.au</li>
                <li>ns2.infinite.net.au</li>
              </ul>
            </Panel.Body>
          </Panel>
        </Col>

        <Col md={8} mdPull={4}>
          <FormField
            bsSize="large"
            controlId="domainName"
            controlLabel="Domain Name"
            errors={errors}
            errorKey="data[hostname]"
            onChange={e => setData('hostname', e.target.value)}
            required
            value={signup.getIn(['data', 'hostname']) || ''}
          >
            {control => (
              <div>
                {control}

                <HelpBlock>
                  Enter the domain name you want to use for this hosting
                  account. This system will not register the domain name for
                  you. In order to register a domain, please visit{' '}
                  <a href="https://domains.infinite.net.au">
                    https://domains.infinite.net.au
                  </a>
                  .
                </HelpBlock>
              </div>
            )}
          </FormField>
        </Col>
      </Row>
    </div>
  )
}

HostnameDetails.propTypes = {
  errors: Ipt.map.isRequired,
  setData: Pt.func.isRequired,
  signup: Ipt.record.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/Signup/ServiceDetail/HostnameDetails.jsx